import axios from 'axios';

const useGetStandardizationProject = () => {

  const getProject = async (projectId) => {
    return await axios.get(`/standardization/${projectId}`);
  };

  return {
    getProject,
  };
};

export default useGetStandardizationProject;
